import React, { useEffect } from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import OilThumb from '../../OilThumb';
import OilBaseInfomation from '../../OilBaseInfomation';
import OilVolumesService from '../../OilVolumesService';
import localesReplacement from '../../../../utils/localesReplacement';
import {
  IComponentVolumes,
  IProd,
  IServiceIntervals,
  IState,
  ProductCategory,
  Replacement,
} from '../../../../interface';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import actions from '../../../../redux/actions';
import { useAnalytics } from '../../../../hooks/use-analytics'
import { ANALYTICS_BUTTON_NAME, ANALYTICS_EVENT, ANALYTICS_PAGE_TYPE } from '../../../../constants';

const cx = classnames.bind(style);

interface IProps {
  dataList: IProd;
  serviceIntervals: IServiceIntervals[];
  vehicleComponentVolumes: IComponentVolumes[];
  setVehicleComponentVolumes: (value: IComponentVolumes[]) => void;
  setServiceIntervals: (value: IServiceIntervals[]) => void;
  productCategories: ProductCategory[];
  replacements: Replacement;
  notes?: string[];
}

export const Information = (props: IProps) => {
  const {
    dataList,
    serviceIntervals,
    vehicleComponentVolumes,
    setServiceIntervals,
    setVehicleComponentVolumes,
    productCategories,
    replacements,
    notes,
  } = props;
  const sendAnalytics = useAnalytics();
  useEffect(() => {
    sendAnalytics({
      event: ANALYTICS_EVENT.PRODUCT_VIEW,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_PAGE,
      oilName: dataList?.name,
      country: localStorage.getItem('countryCode') || '',
    });
    return () => {
      setServiceIntervals([]);
      setVehicleComponentVolumes([]);
    };
  }, []);
  const pdsDataLayer = () => {
    sendAnalytics({
      event: ANALYTICS_EVENT.DATASHEET_CLICK,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_PAGE,
      button: ANALYTICS_BUTTON_NAME.DATASHEETS,
      oilName: dataList?.name,
      country: localStorage.getItem('countryCode') || '',
    });
  };
  const msdsDataLayer = () => {
    sendAnalytics({
      event: ANALYTICS_EVENT.MATERIAL_SAFETY_DATASHEET_CLICK,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_PAGE,
      button: ANALYTICS_BUTTON_NAME.MATERIAL_SAFETY_DATASHEETS,
      oilName: dataList?.name,
      country: localStorage.getItem('countryCode') || '',
    });
  };
  return dataList ? (
    <div className={cx('section')}>
      <div className={cx('sider')}>
        <OilThumb
          withoutMoreLink={true}
          products={dataList}
          Recommendation='product page'
          dataList={{
            id: dataList.id,
            packartUrl: (dataList.packartUrl?.[0] || dataList.packartUrl) ? dataList.packartUrl : undefined,
            productCategoryId: dataList.productCategoryId,
            links: dataList.links,
          }}
          maxSize={170}
        />
      </div>
      <div className={cx('content')}>
        <h4 className={cx('name')}>{dataList['name']}</h4>
        <OilBaseInfomation
          withoutMoreLink={true}
          dataList={dataList}
          productCategories={productCategories}
          withTitle={true}
          fullText={true}
        />
        {!_.isEmpty(vehicleComponentVolumes) && (
          <OilVolumesService
            notes={notes}
            withoutMoreLink={true}
            dataList={{ ...dataList, serviceIntervals }}
            componentVolumes={vehicleComponentVolumes}
          />
        )}
        <div className={style['links']}>
          {dataList.msdsUrl && (
            <a
              onClick={msdsDataLayer}
              href={dataList.msdsUrl}
              target='_blank'
              rel='noreferrer'
              className='secondary-button'
              role='button'
            >
              {localesReplacement(replacements, 'Material Safety Data Sheets')}
            </a>
          )}
          {dataList.pdsUrl && (
            <a
              onClick={pdsDataLayer}
              href={dataList.pdsUrl}
              target='_blank'
              rel='noreferrer'
              className='secondary-button'
              role='button'
            >
              {localesReplacement(replacements, 'Data Sheets')}
            </a>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

const mapStateToProps = (state: IState) => ({
  serviceIntervals: state.serviceIntervals,
  vehicleComponentVolumes: state.vehicleComponentVolumes,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setServiceIntervals: (value: IServiceIntervals[]) =>
    dispatch(actions.setServiceIntervals(value)),
  setVehicleComponentVolumes: (value: IComponentVolumes[]) =>
    dispatch(actions.setVehicleComponentVolumes(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Information);
